import { render, staticRenderFns } from "./DashboardSupplyChain.vue?vue&type=template&id=cffa712e&scoped=true&"
import script from "./DashboardSupplyChain.vue?vue&type=script&lang=js&"
export * from "./DashboardSupplyChain.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSupplyChain.vue?vue&type=style&index=0&id=cffa712e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffa712e",
  null
  
)

export default component.exports